import { useEffect, useMemo, useState } from 'react';
import type { GamePlayerProjectionTrading } from '@library/types/trading';
import type { LeagueProjectionAttributes } from '@library/types/leagues';
import type { PlayerDescriptors } from '@library/types/player';
import { getFilteredCopiedProjections } from '@bo-utils/copyProjections';

export const useCopyProjections = ({
  durations,
  fetchedProjections,
  gameStartTime,
  playerDescriptors,
  selectedLeagueName,
  selectedDuration,
  statTypes
}: {
  durations: LeagueProjectionAttributes[] | undefined;
  gameStartTime: string | undefined;
  fetchedProjections: Array<GamePlayerProjectionTrading>;
  playerDescriptors: PlayerDescriptors;
  selectedLeagueName: string;
  selectedDuration: string;
  statTypes: Array<LeagueProjectionAttributes>;
}) => {
  const [copiedProjections, setCopiedProjections] = useState<
    Array<GamePlayerProjectionTrading>
  >([]);

  const selectedDurationInfo = useMemo(
    () =>
      durations?.find(
        (duration) => duration.leagueProjectionFilterId === selectedDuration
      ),
    [durations, selectedDuration]
  );

  const isFullDuration =
    selectedDurationInfo?.leagueProjectionFilterName === 'Full';

  useEffect(() => {
    if (isFullDuration) {
      setCopiedProjections([]);
    }
  }, [isFullDuration, selectedDurationInfo]);

  const handleCopyProjections = ({
    projections
  }: {
    projections: Array<GamePlayerProjectionTrading>;
  }) => {
    if (isFullDuration) {
      setCopiedProjections(projections);
    }
  };

  const filteredCopiedProjections = getFilteredCopiedProjections({
    copiedProjections,
    durations: durations ?? [],
    durationId: selectedDuration,
    fetchedProjections,
    gameStartTime,
    leagueName: selectedLeagueName,
    playerDescriptors,
    statTypes
  });

  return {
    copiedProjections,
    isFullDuration,
    handleCopyProjections,
    filteredCopiedProjections
  };
};
